/** Attribute spread for a guide anchor. The value is the step's `anchor` id. */
export function guideAnchor(id: string): { 'data-guide': string } {
  return { 'data-guide': id };
}
